import styled from 'styled-components';
import config from 'config';

import {
  zoomIn,
  fadeIn,
  zoomOutTop,
  fadeInLeft,
  zoomInRotate
} from 'components/Animations';

import Card from 'components/common/Card';

const BASENAME = config.site.baseName;

const LOGO_PROPS = {
  src: `${BASENAME ? '/' : ''}${BASENAME}/img/logo.png`
};

const LOGO_TEST_PROPS = {
  src: `${BASENAME ? '/' : ''}${BASENAME}/img/searchlight.png`
};

export const LoginButtonContain = styled.div`
  padding-bottom: 8px;
  padding-top: 8px;
`;

export const LoginHeader = styled.div`
  display: flex;
  align-items: center;
  height: 60px;
  padding: 16px;
`;

export const LoginContain = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  ${(props) => (props.success ? zoomOutTop : fadeIn)}
`;

export const LoginPanel = styled.div`
  width: 480px;

  margin-top: 10vh;

  ${(props) => props.theme.media.sm.max`
    margin-top: 0px;
    width: 100vw;
  `}

  ${(props) => props.theme.media.lg.min`
    width: 540px;
  `}
`;

export const LoginContent = styled.div`
  padding: 32px 16px;
`;

export const LoginCard = styled(Card.Content)`
  position: relative;
  ${zoomIn}

  ${(props) => props.theme.media.sm.max`
    margin: 0px !important;
    box-shadow: none !important;
    border-radius: unset !important;
    height: calc(100vh) !important;
  `}
`;

export const MarginBotton = styled.div`
  margin-bottom: 8px;
`;

export const SearchLightLogo = styled.img`
  height: 80%;
  ${zoomInRotate}
`;

export const SearchLightText = styled.img`
  height: 100%;
  margin-left: 16px;

  ${fadeInLeft}
`;

SearchLightLogo.defaultProps = LOGO_PROPS;
SearchLightText.defaultProps = LOGO_TEST_PROPS;

export const Link = styled.a`
  font-family: 'Roboto';
  color: ${(props) => props.theme.brandColor};
`;

export const LinkContain = styled.div`
  padding: 16px;
  padding-bottom: 0px;
  color: ${(props) => props.theme.mediumGrey};
  text-align: right;
  font-family: 'Roboto';
`;

export const Background = styled.div`
  height: 100vh;
`;

export const LinksContain = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'Roboto';
`;
